import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { SET_PAYER } from './constants';

export const setPayer = (payer) => {
  return createAction({
    type: SET_PAYER,
    payload: payer,
  });
};
